import { type ReactNode, useCallback, useMemo } from "react";
import { GraphQLProvider } from "@package/graphql/react";
import { useAuth0 } from "@auth0/auth0-react";

import { createHasuraClient } from "./client";
import { useAccessToken } from "../auth/hooks";

export const HasuraProvider = ({ children }: { children: ReactNode }) => {
  const token = useAccessToken();
  const { getAccessTokenSilently } = useAuth0();

  const getToken = useCallback(
    () => getAccessTokenSilently({ authorizationParams: { audience: "hasura" } }),
    [getAccessTokenSilently],
  );

  const client = useMemo(() => {
    if (!token.data?.access_token) return null;
    return createHasuraClient(token.data.access_token, getToken);
  }, [token.data, getToken]);

  if (!client) return null;
  return <GraphQLProvider value={client}>{children}</GraphQLProvider>;
};
